export default __webpack_public_path__ + "4164f7925e316fd7bd44060db41a7160.png";